export class AnnotationScaleManager {
    constructor() { }

    /**
     * Calculate the world-space size of a text element to ensure it prints at `targetPaperSizeMM`.
     *
     * Formula: WorldSize = PaperSize * ViewScale
     * e.g. 3mm text at 1:100 scale = 3 * 100 = 300mm (0.3m) in world space (if units are mm).
     * If units are meters: 0.003 * 100 = 0.3m.
     *
     * @param targetPaperSizeMeters Desired height on paper (e.g., 0.003 for 3mm)
     * @param viewScale Denominator (e.g., 100 for 1:100)
     */
    calculateWorldSize(targetPaperSizeMeters: number, viewScale: number): number {
        return targetPaperSizeMeters * viewScale;
    }

    /**
     * Resolve the effective annotation scale denominator of a view.
     * BIM rule: every view owns its scale independently; a missing or
     * invalid value falls back to the project default of 1:100.
     */
    resolveViewScale(view?: { scale?: number } | null): number {
        const scale = view?.scale;
        return typeof scale === 'number' && scale > 0 ? scale : 100;
    }

    /**
     * Convenience: world size for a paper size given in millimeters.
     * e.g. 2.5 mm text at 1:100 -> 0.25 m world size.
     */
    paperMmToWorld(paperMm: number, viewScale: number): number {
        return this.calculateWorldSize(paperMm / 1000, viewScale);
    }

    /**
     * Get standard scales list.
     */
    getStandardScales(): number[] {
        return [1, 5, 10, 20, 50, 100, 200, 500];
    }
}
